import { useEffect } from 'react'
import { useDispatch, useSelect } from '@wordpress/data'
import { store_name } from '../../../../../store/frontend'
import { ThankYou } from '../../ThankYou/ThankYou'
import { PaypalSuccessProps } from './types'
import '../../ThankYou/ThankYou.scss'

export const PaypalSuccess = ({ payerid, paymentid }: PaypalSuccessProps) => {
    const dispatch = useDispatch(store_name)
    // Use paymentid as the token, and 'customer_token' as the type
    useEffect(() => {
        if (paymentid) {
            dispatch.fetchBookingDetails(paymentid, 'payment_id')
        }
    }, [dispatch, paymentid])

    const bookingDetails = useSelect(
        (select: any) =>
            select(store_name).getBookingDetails(paymentid, 'payment_id'),
        [paymentid]
    )

    const isLoaded =
        bookingDetails &&
        (bookingDetails.booking_data || bookingDetails.payment_details)

    if (!isLoaded) {
        return (
            <div
                className={'wbk_thank_you__wrapper'}
                style={{ textAlign: 'center', padding: '48px 0' }}
            >
                <div className={';wbk_thank_you__header'}>
                    <h3>Loading booking details...</h3>
                </div>
            </div>
        )
    }

    return <ThankYou bookingDetails={bookingDetails} />
}
